import { Action, ActionType } from 'typesafe-actions';
import { ofType } from 'redux-observable';
import { Observable, of, OperatorFunction } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { apiClient, ApiType, ApiPaths } from '@shared/apiClient';
import { fromApiRequest } from '@shared/apiClient/fromApiRequest';
import { Actions, actions } from '@redux/modules/carFilter';
import { TypedEpic } from './types';

const fetchFiltersEpic: TypedEpic = (action$: Observable<Action<any>>, state$) =>
  action$.pipe(
    ofType(Actions.GET_CAR_ARGUMENTS),
    withLatestFrom(state$) as unknown as OperatorFunction<
      Action<any>,
      ActionType<typeof actions.getCarArguments.request>[]
    >,
    switchMap(([action]) => {
      const urlParams = action.payload;

      return fromApiRequest((signal) =>
        apiClient.get(ApiType.apimVehicleDataApi, {
          signal,
          url: `${ApiPaths[ApiType.apimVehicleDataApi].modelsearcharguments}?${urlParams}`,
        }),
      ).pipe(
        map((response) => actions.getCarArguments.success(response.data)),
        catchError(() => of(actions.getCarArguments.failure('Could not fetch motortests'))),
      );
    }),
  );

export const epics: TypedEpic[] = [fetchFiltersEpic];
